import './home-packages.scss'

export const component = {
    name: 'home-packages',

    data: {
        active: false,
        index: 0,
        packages: [],
        timeout: null
    },

    computed: {
        positionX() {
            return `${(100 / this.packages.length) * -this.index}%`
        },

        sliderWidth() {
            return `${33.333333 * this.packages.length}%`
        }
    },

    mounted () {
        this.active = true
        setTimeout(() => this.setTimeout(), 4000)
    },

    methods: {
        next() {
            if (this.index + 1 > this.packages.length - 3) {
                return
            }
            clearTimeout(this.timeout)
            this.index = this.index + 1
        },

        prev() {
            if (this.index === 0) {
                return
            }
            clearTimeout(this.timeout)
            this.index = this.index - 1
        },

        setTimeout() {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                let nextIndex = this.index + 1
                if (nextIndex > this.packages.length - 3) {
                    nextIndex = 0
                }
                this.index = nextIndex
                this.setTimeout()
            }, 8000)
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/home-packages/home-packages.js